(function ($) {
    $(document).ready(function () {
        // modify the hamburger button to trigger button group on click
        $('.MainHeader-nav .hamburger').click(function () {
            $('.MainHeader-nav .MainHeader-buttonGroup').toggleClass('active');
            if(window.matchMedia('(max-width: 1230px)').matches){
                $('body').toggleClass('overflow-hidden');
            }
        });

        $('.MainHeader-nav .MainHeader-menu-laptop .fl-has-submenu').click(function (e) {
            if(!$(this).hasClass('fl-active')){
                $('.MainHeader-nav .fl-has-submenu').removeClass('fl-active');
                $('.MainHeader-nav .fl-has-submenu').children('ul').slideUp();
            }
        })
    });
})(jQuery);